// tslint:disable:no-trailing-whitespace
// tslint:disable:member-ordering
import { BaseEntity } from '../base-entity';
import { Account } from './account';
import { Admin } from './admin';
import { Counterparty } from './counterparty';
import { Creditor } from './creditor';
import { Lookup } from './lookup';

/// <code-import> Place custom imports between <code-import> tags

/// </code-import>

/// <module-code> Place module level code between <module-code> tags

/// </module-code>

export class CounterpartyDatum extends BaseEntity  {

  /// <code> Place custom code between <code> tags
  
  /// </code>

  // Generated code. Do not place code below this line.
  counterpartyDataId!: number;
  accountId?: number;
  adminId?: number;
  counterpartyId!: number;
  createdBy!: string;
  createdDate!: Date;
  creditorId?: number;
  data?: string;
  ddata?: Date;
  fdata?: number;
  fieldLookupId!: number;
  flags?: number;
  subType?: number;
  ts!: string;
  updatedBy!: string;
  updatedDate!: Date;
  account!: Account;
  admin!: Admin;
  counterparty!: Counterparty;
  creditor!: Creditor;
  fieldLookup!: Lookup;
}

